import BusinessInfo from './BusinessInfo';
import ContractPayment from './ContractPayment';
import PriceInfo from './PriceInfo';
import SetupPackage from './SetupPackage';
import SignedContract from './SignedContract';
import SignStep from './SignStep';
import SignatureHistory from './SignatureHistory';
import SwitchToAnnualFlow from './SwitchToAnnualFlow';
import YousignContractFlow from './YousignContractFlow';

export default {
  BusinessInfo,
  ContractPayment,
  PriceInfo,
  SetupPackage,
  SignedContract,
  SignStep,
  SignatureHistory,
  SwitchToAnnualFlow,
  YousignContractFlow,
};
